import { createFileRoute } from '@tanstack/react-router';

import AdamPublicScorecardCreatePage from '../views/public-scorecard-create';

export const Route = createFileRoute('/c/adam')({
  validateSearch: (search: Record<string, unknown>) => ({
    code: typeof search.code === 'string' ? search.code : '',
  }),
  component: AdamPublicScorecardRoute,
});

function AdamPublicScorecardRoute() {
  const { code } = Route.useSearch();
  return <AdamPublicScorecardCreatePage code={code} />;
}
